import React from 'react';

export default ({ onFocus, onBlur }) => {
  const focus = React.useRef(false);

  const handleFocus = React.useCallback(() => {
    focus.current = true;
    onFocus();
  }, [onFocus]);

  const handleBlur = React.useCallback(() => {
    focus.current = false;
    onBlur();
  }, [onBlur]);

  React.useEffect(() => {
    return () => {
      if (focus.current) {
        onBlur();
      }
    };
  }, []);

  return {
    onFocus: handleFocus,
    onBlur: handleBlur,
  };
};
